export default "__VITE_ASSET__B23Q2Osk__"